const multipleSlashPattern = /\/{2,}/g;

export function concatUrlSegments(...args: string[]): string {
    if (args.length === 0) {
        return '/';
    }

    const combined = args.join('/');

    return combined.replaceAll(multipleSlashPattern, '/');
}
